import { useEffect, useState } from "react";
import API from "../services/api";
import "../styles/dashboard.css";

export default function CEOApproval() {

  const [claims, setClaims] = useState([]);
  const [managers, setManagers] = useState([]);
  const [selectedManager, setSelectedManager] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const format = (num) =>
    Number(num || 0).toLocaleString();

  // ================= LOAD CLAIMS =================

  const loadClaims = async (
    managerId = ""
  ) => {

    try {

      setError("");
      setLoading(true);

      const url =
        `/ceo/claims${
          managerId
            ? `?manager_id=${managerId}`
            : ""
        }`;

      const res =
        await API.get(url);

      setClaims(res.data || []);

    } catch (err) {

      console.log(err);

      setError(
        "Failed to load claims"
      );

    } finally {

      setLoading(false);
    }
  };

  // ================= LOAD MANAGERS =================

  const loadManagers = async () => {

    try {

      const res =
        await API.get(
          "/ceo/managers"
        );

      setManagers(res.data || []);

    } catch (err) {

      console.log(err);
    }
  };

  // ================= DECISION =================

  const handleDecision = async (
    id,
    decision
  ) => {

    try {

      setLoading(true);

      await API.post(
        `/ceo/decision/${id}`,
        { decision }
      );

      await loadClaims(
        selectedManager
      );

    } catch (err) {

      console.log(err);

      alert("Action failed");

    } finally {

      setLoading(false);
    }
  };

  // ================= INIT =================

  useEffect(() => {

    loadManagers();
    loadClaims();

  }, []);

  return (

    <div
      className="dashboard-container"
      style={styles.container}
    >

      {/* ================= HEADING ================= */}

      <div style={styles.headerBox}>

        <div>

          <h1 style={styles.heading}>
            Final Approval
          </h1>

          <p style={styles.subHeading}>
            CEO Claim Approval Panel
          </p>

        </div>

      </div>

      {/* ================= FILTER ================= */}

      <div
        className="top-bar"
        style={styles.topBar}
      >

        <select
          className="input"
          style={styles.select}
          value={selectedManager}
          onChange={(e) => {

            const val =
              e.target.value;

            setSelectedManager(val);

            loadClaims(val);
          }}
        >

          <option value="">
            All Managers
          </option>

          {managers.map((m) => (

            <option
              key={m.id}
              value={m.id}
            >
              {m.name}
            </option>

          ))}

        </select>

      </div>

      {/* ================= STATES ================= */}

      {loading && (

        <div style={styles.loadingBox}>
          Processing...
        </div>
      )}

      {error && (

        <div style={styles.errorBox}>
          {error}
        </div>
      )}

      {/* ================= DESKTOP TABLE ================= */}

      <div
        className="table-card desktop-only"
        style={styles.tableWrapper}
      >

        <table
          className="table"
          style={styles.table}
        >

          <thead>

            <tr>

              <th style={styles.th}>
                Salesman
              </th>

              <th style={styles.th}>
                Dealer
              </th>

              <th style={styles.th}>
                Customer
              </th>

              <th style={styles.th}>
                Mobile
              </th>

              <th style={styles.th}>
                City
              </th>

              <th style={styles.th}>
                QR
              </th>

              <th style={styles.th}>
                Date
              </th>

              <th style={styles.th}>
                Amount
              </th>

              <th style={styles.th}>
                Manager
              </th>

              <th style={styles.th}>
                Final
              </th>

              <th style={styles.th}>
                Action
              </th>

            </tr>

          </thead>

          <tbody>

            {claims.length === 0 ? (

              <tr>

                <td
                  colSpan="11"
                  style={{
                    textAlign: "center",
                    padding: 30
                  }}
                >
                  No claims found
                </td>

              </tr>

            ) : (

              claims.map((c) => (

                <tr key={c.id}>

                  <td style={styles.td}>
                    {c.salesman_name}
                  </td>

                  <td style={styles.td}>
                    {c.dealer_name}
                  </td>

                  <td style={styles.td}>
                    {c.customer_name}
                  </td>

                  <td style={styles.td}>
                    {c.customer_mobile}
                  </td>

                  <td style={styles.td}>
                    {c.city}
                  </td>

                  <td style={styles.td}>
                    {c.qr_value}
                  </td>

                  <td style={styles.td}>
                    {
                      new Date(c.created_at)
                        .toLocaleDateString()
                    }
                  </td>

                  <td style={styles.td}>
                    <b>
                      Rs {
                        format(
                          c.claim_amount
                        )
                      }
                    </b>
                  </td>

                  <td style={styles.td}>

                    <span
                      className={
                        `badge badge-${c.manager_status}`
                      }
                    >
                      {c.manager_status}
                    </span>

                  </td>

                  <td style={styles.td}>

                    <span
                      className={
                        `badge badge-${c.ceo_status}`
                      }
                    >
                      {c.ceo_status}
                    </span>

                  </td>

                  <td style={styles.td}>

                    {c.ceo_status === "pending" ? (

                      <div style={styles.btnGroup}>

                        <button
                          className="btn btn-approve"
                          style={styles.desktopBtn}
                          disabled={loading}
                          onClick={() =>
                            handleDecision(
                              c.id,
                              "approved"
                            )
                          }
                        >
                          ✔
                        </button>

                        <button
                          className="btn btn-reject"
                          style={styles.desktopBtn}
                          disabled={loading}
                          onClick={() =>
                            handleDecision(
                              c.id,
                              "rejected"
                            )
                          }
                        >
                          ✖
                        </button>

                      </div>

                    ) : (

                      <span
                        style={{
                          color: "gray"
                        }}
                      >
                        Locked
                      </span>

                    )}

                  </td>

                </tr>

              ))
            )}

          </tbody>

        </table>

      </div>

      {/* ================= MOBILE CARDS ================= */}

      <div className="mobile-cards">

        {claims.length === 0 ? (

          <div style={styles.emptyCard}>
            No claims found
          </div>

        ) : (

          claims.map((c) => (

            <div
              key={c.id}
              style={styles.mobileCard}
            >

              {/* STATUS BAR */}

              <div
                style={{
                  ...styles.statusBar,

                  background:

                    c.ceo_status ===
                    "approved"

                      ? "#16a34a"

                      : c.ceo_status ===
                        "rejected"

                      ? "#dc2626"

                      : "#f59e0b"
                }}
              />

              {/* HEADER */}

              <div style={styles.mobileHeader}>

                <div>

                  <h2 style={styles.customerName}>
                    {c.customer_name}
                  </h2>

                  <p style={styles.customerMobile}>
                    {c.customer_mobile}
                  </p>

                </div>

                <div
                  style={{
                    ...styles.statusPill,

                    background:

                      c.ceo_status ===
                      "approved"

                        ? "#dcfce7"

                        : c.ceo_status ===
                          "rejected"

                        ? "#fee2e2"

                        : "#fef3c7",

                    color:

                      c.ceo_status ===
                      "approved"

                        ? "#166534"

                        : c.ceo_status ===
                          "rejected"

                        ? "#991b1b"

                        : "#92400e"
                  }}
                >

                  {c.ceo_status}

                </div>

              </div>

              {/* AMOUNT */}

              <div style={styles.amountBox}>

                <p style={styles.amountLabel}>
                  Claim Amount
                </p>

                <h1 style={styles.amountText}>
                  Rs {
                    format(
                      c.claim_amount
                    )
                  }
                </h1>

              </div>

              {/* DETAILS */}

              <div style={styles.detailsGrid}>

                <div>
                  <p style={styles.mobileLabel}>
                    Salesman
                  </p>

                  <h4 style={styles.mobileValue}>
                    {c.salesman_name}
                  </h4>
                </div>

                <div>
                  <p style={styles.mobileLabel}>
                    Dealer
                  </p>

                  <h4 style={styles.mobileValue}>
                    {c.dealer_name}
                  </h4>
                </div>

                <div>
                  <p style={styles.mobileLabel}>
                    City
                  </p>

                  <h4 style={styles.mobileValue}>
                    {c.city}
                  </h4>
                </div>

                <div>
                  <p style={styles.mobileLabel}>
                    QR
                  </p>

                  <h4 style={styles.mobileValue}>
                    {c.qr_value}
                  </h4>
                </div>

              </div>

              {/* FOOTER */}

              <div style={styles.footer}>

                <div>

                  <p style={styles.mobileLabel}>
                    Date
                  </p>

                  <h4 style={styles.mobileValue}>
                    {
                      new Date(
                        c.created_at
                      ).toLocaleDateString()
                    }
                  </h4>

                </div>

                <div style={{ textAlign: "right" }}>

                  <p style={styles.mobileLabel}>
                    Manager
                  </p>

                  <span
                    className={
                      `badge badge-${c.manager_status}`
                    }
                  >
                    {c.manager_status}
                  </span>

                </div>

              </div>

              {/* ACTIONS */}

              {c.ceo_status ===
                "pending" && (

                <div style={styles.mobileActions}>

                  <button

                    className="btn btn-approve"

                    style={styles.actionBtn}

                    onClick={() =>
                      handleDecision(
                        c.id,
                        "approved"
                      )
                    }
                  >

                    ✓ Approve

                  </button>

                  <button

                    className="btn btn-reject"

                    style={styles.actionBtn}

                    onClick={() =>
                      handleDecision(
                        c.id,
                        "rejected"
                      )
                    }
                  >

                    ✕ Reject

                  </button>

                </div>
              )}

            </div>

          ))
        )}

      </div>

    </div>
  );
}

// ================= STYLES =================

const styles = {

  container: {
    width: "100%",
    overflowX: "hidden"
  },

  headerBox: {
    marginBottom: 20
  },

  heading: {
    margin: 0,
    fontSize: 30,
    fontWeight: 800,
    color: "#1e293b"
  },

  subHeading: {
    marginTop: 6,
    color: "#64748b",
    fontSize: 14
  },

  topBar: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    marginBottom: 20
  },

  select: {
    minWidth: 220,
    width: "100%",
    maxWidth: 350
  },

  loadingBox: {
    padding: 14,
    background: "#eff6ff",
    borderRadius: 14,
    marginBottom: 16
  },

  errorBox: {
    padding: 14,
    background: "#fee2e2",
    color: "#991b1b",
    borderRadius: 14,
    marginBottom: 16
  },

  tableWrapper: {
    width: "100%",
    overflowX: "auto",
    borderRadius: 16
  },

  table: {
    width: "100%",
    minWidth: 1200,
    borderCollapse: "collapse"
  },

  th: {
    whiteSpace: "nowrap",
    padding: 14,
    fontSize: 14,
    background: "#2c5178",
    color: "#fff"
  },

  td: {
    whiteSpace: "nowrap",
    padding: 14,
    fontSize: 14
  },

  btnGroup: {
    display: "flex",
    gap: 8
  },

  desktopBtn: {
    minWidth: 42,
    minHeight: 38
  },

  emptyCard: {
    background: "#fff",
    padding: 24,
    borderRadius: 24,
    textAlign: "center",
    boxShadow:
      "0 6px 20px rgba(0,0,0,0.06)"
  },

  mobileCard: {

    background:
      "linear-gradient(180deg,#ffffff 0%,#f8fbff 100%)",

    borderRadius: 28,

    padding: 20,

    marginBottom: 18,

    boxShadow:
      "0 10px 25px rgba(0,0,0,0.08)",

    border:
      "1px solid rgba(44,81,120,0.08)",

    overflow: "hidden",

    position: "relative"
  },

  statusBar: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: 6
  },

  mobileHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 20,
    marginTop: 6
  },

  customerName: {
    margin: 0,
    fontSize: 20,
    fontWeight: 800,
    color: "#1e293b"
  },

  customerMobile: {
    marginTop: 6,
    fontSize: 13,
    color: "#64748b"
  },

  statusPill: {
    padding: "8px 14px",
    borderRadius: 999,
    fontWeight: 700,
    fontSize: 12,
    textTransform: "capitalize"
  },

  amountBox: {
    background:
      "linear-gradient(135deg,#2c5178 0%,#406b96 100%)",
    borderRadius: 22,
    padding: 18,
    color: "#fff",
    marginBottom: 18
  },

  amountLabel: {
    margin: 0,
    opacity: 0.8,
    fontSize: 13
  },

  amountText: {
    margin: "6px 0 0",
    fontSize: 30,
    fontWeight: 900
  },

  detailsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 16
  },

  mobileLabel: {
    margin: 0,
    fontSize: 12,
    color: "#64748b",
    fontWeight: 600
  },

  mobileValue: {
    marginTop: 5,
    marginBottom: 0,
    fontSize: 15,
    fontWeight: 700,
    color: "#1e293b"
  },

  footer: {
    marginTop: 20,
    paddingTop: 16,
    borderTop:
      "1px dashed #dbe4ee",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },

  mobileActions: {
    display: "flex",
    gap: 14,
    marginTop: 22
  },

  actionBtn: {
    flex: 1,
    height: 48,
    borderRadius: 16,
    fontWeight: 800,
    fontSize: 15
  }
};